import React from 'react';

const CreditRangeFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.6114 16.8962H10.5588C10.2973 16.8962 10.0851 16.7042 10.0851 16.4677V11.3248C10.0851 11.0882 10.2973 10.8962 10.5588 10.8962H18.6114C18.8729 10.8962 19.0851 11.0882 19.0851 11.3248V16.4677C19.0851 16.7042 18.8729 16.8962 18.6114 16.8962Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M18.8408 13.6216L10.3408 13.6217" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M7.84082 11.5922H2.57611L1.34082 11.6216V12.8275V14.4745H7.84082M1.34082 5.82746V5.00394L8.34082 2.12158L15.3408 5.00394V5.82746H1.34082Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.84082 11.5921V5.82739M6.34082 5.82739V11.5921M10.9658 6.2024V8.62152M13.282 8.62152V5.82739"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CreditRangeFilterIcon;
